export default "__VITE_ASSET__CbnpcPOO__"